import { toWei } from 'utils/crypto'

const numbers = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  TEN: 10,
  FIFTEEN: 15,
  ONE_HUNDRED: 100,
  MAX_PERCENT: 100,
  ONE_THOUSAND: 1000,
}

const etherNumbers = {
  WEI: 1e18,
  GWEI: 1e9,
  WEI_DECIMALS: 18,
  GWEI_DECIMALS: 9,
  ONE_ETHER: toWei('1'),
  BG_ZERO: BigInt(0),

  MIN_GAS_PRICE: 5,
  MAX_GAS_PRICE: 10000,
  MARKET_INCREASE: 1250,
  CONTRACT_CONSTANTS_DECIMALS: 4,
  CONTRACTS_CONSTANTS_DENOMINATOR: 10000,
  TRANSFER_GAS_LIMIT: BigInt(21000),
  SELF_GENERATE_BUMP_GAS: BigInt(10_000),
  MAX_UINT: BigInt('115792089237316195423570985008687907853269984665640564039457584007913129639935'),
}

const timeNumbers = {
  SECOND: 1000,
  MINUTE: 60000,
  SECONDS_IN_MINUTE: 60,
  SECONDS_IN_YEAR: 31536000,

  COPY_DELAY: 800,
  CALL_API_DEBOUNCE: 300,
  NOTIFY_HIDE_DELAY: 4000,
  CHECK_FIELD_DELAY: 1000,
  NOTIFY_REMOVE_DELAY: 400,
  CLOSE_MODAL_DELAY: 10000,
}

const manualBatchCount = 4

const signMessage = `By signing, you accept the terms of use and condition agreement.`

const appName = 'Mad Assembly'
const WALLET_CONNECT_PROJECT_ID = 'b68665ee7e6357843e6e54788fc0dd7c'

enum badgeTypes {
  FAIL = 'failed',
  SUCCESS = 'success',
  PENDING = 'pending',
}

export {
  numbers,
  appName,
  badgeTypes,
  signMessage,
  timeNumbers,
  etherNumbers,
  manualBatchCount,
  WALLET_CONNECT_PROJECT_ID,
}
